export const toIdArray = (val: unknown): string[] => {
  if (Array.isArray(val)) return val.filter((v): v is string => typeof v === 'string' && !!v)
  if (val == null) return []
  if (typeof val === 'string')
    return val
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
  if (val instanceof Set) return Array.from(val).map(String).filter(Boolean)
  if (typeof val === 'object')
    return Object.values(val as Record<string, unknown>)
      .map(String)
      .filter(Boolean)
  return []
}
